import React, { useState, useCallback, useEffect, useRef } from "react";
import { Bubble, GiftedChat, InputToolbar,Send } from "react-web-gifted-chat";

import {
  NUMBER_OF_EARLIER_MESSAGES,
  NUMBER_OF_INITIAL_MESSAGES,
  ROOT_URL,
} from "./constants";

const App = (props) => {
  const [messages, setMessages] = useState([]);
  const [lastMessageId, setLastMessageId] = useState(undefined);
  const [stopSending, setStopSending] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  
  const {userName, farmId, userId, requestFrom} = props;
  const ws = useRef(new WebSocket(`${ROOT_URL[requestFrom]}cable`)).current;
  const interval = useRef();

  const checkOffline = () => {
    const msg = {
      command: "message",
      data: JSON.stringify({
        action: "check_offline",
      }),

      identifier: JSON.stringify({
        id: farmId,
        userId,
        channel: "ChatRoomChannel",
      }),
    };

    try {
      ws.send(JSON.stringify(msg));
    } catch (e) {
      clearInterval(interval.current);
      console.log(">>>>>>>>>> Error: ", e);
    }
  }

  useEffect(() => {
    console.log(`initializing interval`);
    interval.current = setInterval(() => {
      checkOffline();
    }, 1000);
  
    return () => {
      console.log(`clearing interval`);
      clearInterval(interval.current);
    };
  }, []);

  useEffect(() => {
    ws.onopen = () => {
      console.log('Connected to the serverrrrrrrrrrrrrrrrrrrrrrrrrrrrr');
      const msg = {
        command: 'subscribe',
        identifier: JSON.stringify({
          id: farmId,
          userId,
          channel: 'ChatRoomChannel',
        }),
      };
      ws.send(JSON.stringify(msg));
    };

    return () => {
      ws.close();
    };
  }, []);

  useEffect(() => {
    ws.onmessage = (e) => {
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>: ", JSON.parse(e.data));
      const data = JSON.parse(e.data);
      if (data && data.type === 'confirm_subscription') {
        initialMessages();
        return;
      }

      if (data && data.message && data.message.action === 'check_offline' && data.message.isOffline) {
        clearInterval(interval.current);
        ws.close();
        return;
      }

      if (data && data.message && data.message.action === 'message') {
        setMessages((previousMessages) =>
          GiftedChat.append(previousMessages, data.message.content),
        );

        return;
      }

      if (data && data.message && data.message.action === 'initial_messages') {
        setIsLoading(false)
        console.log("enter in initial ")
        const msgs = data.message.content;

        if (msgs.length > 0) {
          setLastMessageId(msgs[msgs.length - 1].id)
          setMessages([...msgs]);
        }
        if (msgs.length < NUMBER_OF_EARLIER_MESSAGES) {
          setStopSending(true)
        }
        return;
      }

      if (data && data.message && data.message.action === 'earlier_messages') {
        setIsLoading(false)
        console.log("earlierrrrrrrrrrrrrrrrrrrr", messages)
        const msgs = data.message.content;

        if (msgs.length > 0) {
          setLastMessageId(msgs[msgs.length - 1].id)
          setMessages([...messages, ...msgs]);
          if (msgs.length < NUMBER_OF_EARLIER_MESSAGES) {
            setStopSending(true)
          }
        }

        return;
      }
    };

    ws.onclose = (e) => {
      console.log(
        'Disconnected. Check internet or server.rrrrrrrrrrrrrrrrrrrrrrrrr',
      );
    };

    ws.onerror = (e) => {
      console.log('errorrrrrrr', e);
    };
  }, [messages]);

  const onSend = useCallback((messages) => {
    const msg = {
      command: "message",
      data: JSON.stringify({
        action: "message",
        content: {...messages[0], _id: messages[0].id},
      }),
      identifier: JSON.stringify({
        id: farmId,
        userId,
        channel: "ChatRoomChannel",
      }),
    };


    // console.log('value of message', msg);
    ws.send(JSON.stringify(msg));
  });

  // message.last_message_id
  // message.limit

  const initialMessages = () => {
    const msg = {
      command: "message",
      data: JSON.stringify({
        action: "initial_messages",
        limit: NUMBER_OF_INITIAL_MESSAGES,
      }),
      identifier: JSON.stringify({
        id: farmId,
        userId,
        channel: "ChatRoomChannel",
      }),
    };

    ws.send(JSON.stringify(msg));
  }

  const earlierMessages = () => {
    
    if (!lastMessageId || stopSending) return;
    setIsLoading(true)
    const msgg = {
      command: "message",
      data: JSON.stringify({
        action: "earlier_messages",
        last_message_id: lastMessageId,
        limit: NUMBER_OF_EARLIER_MESSAGES,
      }),
      identifier: JSON.stringify({
        id: farmId,
        userId,
        channel: "ChatRoomChannel",
      }),
    };

    ws.send(JSON.stringify(msgg));
  }

  console.log(">>>>>>>>>>>>>>>>>>>>>>>>> userId: ", userId, userName)

  return (
    <div className="App" style={styles.container}>
      <div style={styles.chat}>
        <GiftedChat
          user={{
            id: userId,
            _id: userId,
            name: userName,
          }}
          messages={messages}
          onSend={(messages) => onSend(messages)}
          loadEarlier={isLoading}
          maxInputLength={500}
          isLoadingEarlier={isLoading}
          listViewProps={{
            onEndReached: earlierMessages,
            onEndReachedThreshold: 0.3,
            windowSize: 10,
            initialNumToRender: NUMBER_OF_INITIAL_MESSAGES,
            // scrollEventThrottle: 400,

            // onScroll: ({ nativeEvent }) => { this.setState({toggleScroller: (nativeEvent.contentOffset.y > 50)}) }
          }}
          // loadEarlier={true}
          infiniteScroll={false}
          showAvatarForEveryMessage={true}
         
          multiline={true}
          renderSend = {(props) => {
            //Add the extra styles via containerStyle
           return (
             <Send
              {...props}
                containerStyle = {{
                  backgroundColor: '#12183c',
                  borderRadius: '7px',
                  padding: '10px 3px 3px 3px',
                  position:'relative',
                  top:'-8px'
                }}
                textStyle={{
                  color:'white'
                }}
             />
           );
         }}
          renderInputToolbar= {(props) => {
            //Add the extra styles via containerStyle
           return (
           <InputToolbar 
           {...props} 

           textInputStyle={{
            maxHeight:"60px",
            minHeight:"60px",
            marginTop:"0px"

            }} 
            containerStyle={{
              minHeight:'40px',
              }}               
            />
            );
          }}
          
        
          renderBubble={(props) => {
            return (
              
              <Bubble
                {...props}  
                 textStyle={{
                   right: {
                    paddingVertical: 0.5,
                    color: 'white',
                    paddingHorizontal: 0.5,
                    paddingBottom:0,
                    fontSize: 12,
                    fontWeight: '500',
                    wordBreak:"break-all",
                    lineHeight:"15px",
                  },
                  left: {
                    color: '#ffff',
                    paddingVertical: 1,
                    paddingHorizontal: 10,
                    fontSize: 12,
                    fontWeight: '500',
                    wordBreak:"break-all",
                    lineHeight:"15px",
                  },
                }}
                timeTextStyle={{ 
                        left: { 
                          fontSize: '8px' 
                        },
                        right: {
                          fontSize: '8px'  
                          } 
                          }}
 
                wrapperStyle={{
                  
                    right: {
                      // backgroundColor: '#EFE5D9',
                      borderBottomRightRadius: 0,
                      borderBottomLeftRadius: 12,
                      borderTopRightRadius: 12,
                      borderTopLeftRadius: 12,
        
                    },
                    left: {
                      backgroundColor: 'grey',
                      borderBottomRightRadius: 15,
                      borderBottomLeftRadius: 15,
                      borderTopRightRadius: 15,
                      borderTopLeftRadius: 0,
                    }
                  }}
             />
            );
          }}

          
        />
      </div>
    </div>
  );
// return (
//     <div>Hello</div>
//   )
}

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    height: "100vh",
  },
  conversationList: {
    display: "flex",
    flex: 1,
  },
  chat: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    borderWidth: "0px",
    borderColor: "#ccc",
    borderRightStyle: "solid",
    borderLeftStyle: "solid",
    height:'calc(100% - 40px)'
  },
  converationDetails: {
    display: "flex",
    flex: 1,
  },
};
export default App;
